/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import api from ".";

export const fetchJobs = async (data) => {
  const response = await api.get("/v1/admin/jobs", { params: data });
  return { data: response?.data, pageCount: response?.headers["total-count"] };
};

export const fetchJob = async (id) => {
  const response = await api.get(`/v1/admin/jobs/${id}`);
  return { data: response?.data };
};

export const uploadJobs = async (file, restaurantId) => {
  const formData = new FormData();
  formData.append("jobs_data", file);
  formData.append("restaurant_id", restaurantId);

  const response = await api.post("/v1/admin/jobs/import_jobs_data", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response?.data;
};
